import script from "./dummyData2.vue?vue&type=script&lang=js"
export * from "./dummyData2.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__